/**
 * BOTTOM GENERAL INITS
 */



/**
 * ---------------------------------------------------------------
 * bottom straight Init Stuff
 * ---------------------------------------------------------------
 */

// Init and setup navigation
app.navigation.init();